import axios from 'axios';
import { IDocumentEventItem } from '@/document-view/types/document-events-item';
import { AnalyticsHelper } from '@/document-view/helpers/analytics.helper';

const loadDocumentEvents = async (documentId: string) => {
  const { data }: { data: any } = await axios.get(`/get/document/${documentId}/events`);
  if (!data?.events) {
    return [];
  }
  const events: IDocumentEventItem[] = [];

  data.events.forEach(eventItem => {
    const event: IDocumentEventItem = {
      createdAt: eventItem.created_at,
      fullName: AnalyticsHelper.getFullName(eventItem.first_name, eventItem.last_name),
      eventMetadata: eventItem.event_meta_data,
      eventName: eventItem.event_name,
      thumbUrl: eventItem.thumb_url,
      email: eventItem.email,
    };
    events.push(event);
  });
  return events;
};

export default {
  loadDocumentEvents,
};
